<vwui-header>
    {{ "PAGE_LOGOUT.title" | translate }}
</vwui-header>
{{ 'PAGE_LOGOUT.message' | translate }}
